<template>
  <div class="ps-3 mt-2">
    <div
      v-if="!!responseMessage && !errorMessage"
      class="alert alert-success" role="alert">
      {{ responseMessage }}
    </div>

    <div
      v-if="!!errorMessage"
      class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>

    <table class="table table-bordered table-hover table-responsive" style="cursor: pointer">
      <thead>
      <tr class="bg-tr-color">
        <th>{{trans('invoices.car_name')}}</th>
        <th>{{trans('invoices.status')}}</th>
        <th>{{trans('invoices.amount')}}</th>
        <th>{{trans('invoices.date_sold')}}</th>
        <th>{{trans('invoices.link')}}</th>
        <th>{{trans('invoices.copy')}}</th>
        <th>{{trans('invoices.code')}}</th>
      </tr>
      </thead>
      <tbody class="border-top-0">
      <tr
        v-for="invoice in invoices"
        :key="invoice.id"
      >
        <td>{{ invoice.car_name }}</td>
        <td v-if="invoice.delivery_date === undefined">{{ invoice.status ? trans('invoices.pay') : trans('invoices.not_pay') }}</td>
        <td v-else :class="{ delivery_red: invoice.status_code === 'cancelled' || invoice.status_code === 'failed',
          delivery_green: invoice.status_code === 'completed' }"
        >
          {{ trans('order_deliveries.status.' + invoice.status_code) }}
          <div
            v-if="['paid', 'in_progress', 'pre_trip_inspection', 'post_trip_inspection'].includes(invoice.status_code) && !!invoice.delivery_date"
            class="delivery-info"
          >
            {{ trans('order_deliveries.delivery_date').replace(':delivery_date', invoice.delivery_date)
              .replace(':start_delivery_time', invoice.delivery_start_at)
              .replace(':end_delivery_time', invoice.delivery_end_at)
            }}
          </div>
        </td>
        <td style="white-space:nowrap">{{ invoice.order_price_vat ?? invoice.price ?? invoice.amount }}</td>
        <td>{{ invoice.sale_date }}</td>
        <td v-if="invoice.delivery_date === undefined" style="white-space: nowrap;">
          <a
            v-if="invoice.link"
            :href="invoice.link" target="_blank"
          >
            {{trans('invoices.download')}}
          </a>
        </td>
        <td v-else style="white-space: nowrap;">
          <a
            v-if="!invoice.paid_date && invoice.invoice_link"
            :href="invoice.invoice_link"
            target="_blank"
          >
            {{ trans('order_deliveries.download') }}
          </a>
        </td>
        <td v-if="!invoice.delivery_date">
          <button
            @click="sentInvoiceId = invoice.id; isInvoice = true"
            class="btn btn-tooltip btn-primary"
            :data-tooltip="trans('invoices.tooltip')"
            data-toggle="modal"
            data-target="#sendMail"
          >
            <i class="fas fa-paper-plane"></i>
          </button>
        </td>
        <td v-else>
          <button
              v-if="!invoice.paid_date && invoice.invoice_link"
              class="btn btn-tooltip btn-primary"
              :data-tooltip="trans('order_deliveries.modal.tooltip')"
              data-toggle="modal"
              data-target="#sendMail"
              @click="sentOrderDeliveryId = invoice.id; isInvoice = false"
          >
            <i class="fas fa-paper-plane" />
          </button>
        </td>
        <td style="white-space: nowrap;">
          <a
            v-if="invoice.status && !!invoice.direct_code"
            :href="'/receive/' + invoice.direct_token"
            target=”_blank”
          >
            {{ invoice.direct_code }}
            <i class="fa-solid fa-arrow-up-right-from-square ms-1"></i>
          </a>
          <span v-else-if="!!invoice.pickup_code">
            {{ invoice.pickup_code }}
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <SendInvoiceModal
    modal-id="sendMail"
    :invoicing-email='outletInvoicingEmail'
    @send="isInvoice ? sendMessage : sendDeliveryMessage"
  />
</template>

<script>
import SendInvoiceModal from "./SendInvoiceModal.vue";

export default {
  name: "ListInvoicesComponent",
  components: {SendInvoiceModal},
  props: {
    invoices: {
      type: Array
    },
    outletInvoicingEmail: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      sentInvoiceId: null,
      sentOrderDeliveryId: null,
      responseMessage: '',
      errorMessage: '',
      isInvoice: true,
    }
  },
  methods: {
    sendMessage(invoicingEmail) {
      axios({
        url: `/my/invoices/send/${this.sentInvoiceId}`,
        method: 'POST',
        data: {
          invoicing_mail: invoicingEmail
        }
      }).then(resp => {
        this.errorMessage = '';

        this.responseMessage = resp.data;
      }).catch(err => {
        this.errorMessage = err.message
      }).finally(() => {
        this.sentInvoiceId = null;
      })
    },
    sendDeliveryMessage(email) {
      axios({
        url: `/my/deliveries/send-invoice/${this.sentOrderDeliveryId}`,
        method: 'POST',
        data: {
          email: email
        }
      }).then(resp => {
        this.errorMessage = '';

        this.responseMessage = resp.data;
      }).catch(err => {
        this.errorMessage = err.message
      }).finally(() => {
        this.sentOrderDeliveryId = null;
      })
    }
  }
}
</script>


<style scoped>
  .btn-tooltip {
    position: relative;
  }

  .btn-tooltip::after {
    content: attr(data-tooltip);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 3px;
    border-radius: 4px;
    position: absolute;
    top: -80%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    width: 190px;
  }

  .btn-tooltip:hover::after {
    opacity: 1;
  }
</style>
